import { WelcomeState } from '../components/VisitDictationShared/WelcomeState'

export const DictationWelcomePage = () => {
    return <WelcomeState type="dictation" />
}
